import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import '../index.css'
import {useTranslation} from "react-i18next";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import InstrumentIcon from "../../../components/instrument-icon";
import {GLOBAL_CONSTANTS} from "../../../constants/global-constants";
import SvgIcon from "../../../components/svg-icon";

const PlayGameMobileFrame = (props) => {

    const {t} = useTranslation()
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {gameSelectedCurrency, isGameFullScreen} = useSelector(state => state.globalReducer)

    const [filteredCurrencies, setFilteredCurrencies] = useState([])
    const {
        handleSetGameType,
        currencies,
        game,
        // setFullScreen,
        // fullScreen
    } = props


    const [search, setSearch] = useState('')
    useEffect(() => {
        setFilteredCurrencies(currencies?.filter(
            i => i?.toUpperCase().includes(search?.toUpperCase())))
    }, [currencies, search])
    const handleChangeWallet = wall => {

        document.getElementById('modalWalet0')?.classList?.remove('show')
        document.getElementById('dropdown-menu-modal__wallet-menu')?.classList?.remove('show')
        setSearch('')

        store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(wall))
    }
    return (
        <div className="frame-mob">
            <div className="frame-mob__cover">
                <a
                    className="slot slot--carousel">
                    <div className={`slot__cover slot__cover--${game?.color === 'no' ? 'no-layer' : ''}`}>
                        <span className="slot__img">
                            <img src={game?.image} alt=""/>
                        </span>

                        <div className={`slot__title slot__title--${game?.color}`}>
                            <h3>{game?.name}</h3>
                            <span className="game-provider">{game?.provider || '-'}</span>
                        </div>

                    </div>

                </a>
            </div>
            <div className="frame-mob__title">
                <h2>{game?.name}</h2>
                <a onClick={null}>{game?.provider}</a>
            </div>
            <div className="frame-mob__content">
                <div className="frame-mob__balance">
                    <button
                        className="modal__wallet-dropdown-btn"
                        type="button"
                        id="modalWalet0"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <div className="d-flex align-items-center justify-content-center gap-2">
                            {t('game.balance-in')}
                            <div className="d-flex align-items-center g-8">
                                <InstrumentIcon code={gameSelectedCurrency}/>
                                {gameSelectedCurrency}
                            </div>
                        </div>


                        <SvgIcon id={'right-down'}/>
                    </button>

                    <div className="dropdown-menu modal__wallet-menu" id="dropdown-menu-modal__wallet-menu"
                         aria-labelledby="modalWalet0">

                        <div className="modal__wallet-search">
                            <div className="search">
                                <input
                                    value={search}
                                    name="search"
                                    onChange={e => setSearch(e.target.value)}
                                    type="text"
                                    className="search__input"
                                    placeholder={t('general.search')}
                                />
                            </div>
                        </div>


                        <ul className="modal__wallet-currencies">
                            {
                                filteredCurrencies?.map((wall, i) => (
                                    <li key={i}
                                        onClick={e => handleChangeWallet(wall)}>
                                        <span className="gapp2">
                                            <InstrumentIcon code={wall}/>
                                            {wall}
                                        </span>
                                    </li>
                                ))
                            }
                        </ul>

                    </div>

                </div>
                <div className="form__switch">
                    <input
                        checked={isGameFullScreen}
                        onChange={e => store.dispatch({
                            type: GLOBAL_CONSTANTS.SET_GAME_FULLSCREEN,
                            data: e.target.checked
                        })}
                        type="checkbox" className="form__switch-input" name="switch010" id="switch010"/>
                    <label htmlFor="switch010">
                        <p>{t('game.fullscreen')}</p>
                    </label>
                </div>

                <div className="frame-mob__btns">
                    {
                        authenticated ? <button
                                onClick={e => handleSetGameType('real')}
                                className="frame__btn" type="button">
                                {t('game.real-play')}
                            </button> :
                            <button
                                onClick={e => handleSetGameType('register')}
                                className="frame__btn" type="button">
                                {t('general.sign-up')}
                            </button>
                    }

                    {
                        game?.is_live || !game?.has_demo ? null :
                            <button
                                onClick={e => handleSetGameType('demo')}
                                className="frame__play" type="button">
                                <SvgIcon id={'play'}/>
                                {t('game.demo-play')}

                            </button>
                    }
                </div>
            </div>
        </div>
    )


}

export default PlayGameMobileFrame
